// src/config.js
const config = {
  // apiBasePath: process.env.REACT_APP_API_BASE_PATH || 'http://localhost',
  // apiBasePath: process.env.REACT_APP_API_BASE_PATH || 'https://arxis.local',
  apiBasePath: process.env.REACT_APP_API_BASE_PATH || 'https://api.arxistechnologies.com',
};

export default config;
